import FavoriteLink from './FavoriteLink';

export default FavoriteLink;
